import bannerMessage from './banner-message';

const UPDATE_INTERVAL = 10 * 60000;

let timeoutKey = null;
let isFetching = false;
let isMessageDisplayed = false;

/**
 * Checks for build timestamp after a set interval.
 * Resets interval if manually called.
 */
async function updateCheck () {
  if (
    isFetching ||
    isMessageDisplayed ||
    process.env.NODE_ENV !== 'production'
  ) {
    return;
  }

  clearTimeout(timeoutKey);

  const updated = await hasUpdate()
    .catch(console.error)
    .finally(() => {
      isFetching = false;
    });

  if (updated) {
    isMessageDisplayed = true;
    bannerMessage(
      'The site has an update available. Please refresh your browser.',
      () => {
        isMessageDisplayed = false;
      }
    );
  } else {
    // Check again later
    timeoutKey = setTimeout(updateCheck, UPDATE_INTERVAL);
  }
}

async function hasUpdate () {
  isFetching = true;

  const res = await fetch('Scripts/dist/timestamp.json', { cache: 'no-cache' });

  if (!res.ok) {
    // Site is in the middle of updating
    return false;
  }

  const data = await res.json();

  return process.env.timestamp < data.timestamp;
}

export default updateCheck;
